import {
    CoachingEventStatus,
    CommitmentDto,
} from '../../coaching-base/general';
import { TranslationKeyMap } from '../coaching-commitment.i18n';

import { MirrorCopyAlertInfoView } from './mirror-copy-alert-info-view.model';

export function mirrorCopyAlertInfoViewTransformer(
    commitment: CommitmentDto,
    draftId?: string,
    isEdit?: boolean,
): MirrorCopyAlertInfoView {
    const markup: MirrorCopyAlertInfoView = {};

    // checking mirror copy only for active commitments
    if (commitment && commitment.statusId === CoachingEventStatus.ACTIVE) {
        const daa = commitment.draftAndApproval;
        const activeText =
            TranslationKeyMap._9802_IF_YOU_WANT_TO_UPDATE_THIS_COMMITMENT_PLEASE_GO_TO_THE_DRAFT;
        const draftText =
            TranslationKeyMap._9803_THIS_DRAFT_HAS_AN_ACTIVE_COMMITMENT;
        markup.borderColor = '#d17300';
        markup.backgroundColor = '#ffedd6';

        if (
            daa &&
            daa.isOriginalCommitment === true &&
            daa.draftId != null &&
            isEdit
        ) {
            markup.isOriginalCommitment = daa.isOriginalCommitment
                ? daa.isOriginalCommitment
                : false;
            markup.messagePrefix = activeText;
            return markup;
        }
        if (daa == null && draftId) {
            markup.isOriginalCommitment = false;
            markup.messagePrefix = draftText;
            return markup;
        }
    }
    return null;
}
